var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "import-file is-required",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload",
          attrs: {
            action: _vm.formAction,
            headers: _vm.headers,
            data: _vm.options,
            limit: 1,
            "auto-upload": false,
            "on-success": _vm.importSuccess,
            "on-error": _vm.importError,
            "http-request": _vm.httpRequest,
            disabled: _vm.disabled,
            autofocus: _vm.autofocus
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: { slot: "trigger" },
              on: { click: _vm.clear },
              slot: "trigger"
            },
            [_vm._v("選択")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }